<div>
  <app-header></app-header>
</div>
<div class="container-fluid mt-1 maindiv" >
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 backbutton mb-3" (click)="goButtonBack()">
       
      <span *ngIf="!utmData?.utm_source">  <img src="../../../assets/images/icons/back-button.png" alt="" srcset="">  Back </span>
    </div>
    <div class="col-md-6">
      <div class="productimgBox">
        <ng-container *ngIf="selectedImage">
          <span *ngIf="productData?.is_sold == true" class="newtick">Sold Out</span>
          <img *ngIf="!selectedImage.url.endsWith('.mp4')" [src]="selectedImage?.url"
            [alt]="productData?.title || 'Product'" class="product-main-img" />
          <video *ngIf="selectedImage.url.endsWith('.mp4')" class="videoBackground product-sub-main-img" controls>
            <source [src]="selectedImage.url" type="video/mp4" width="100%" />
            Your browser does not support the video tag.
          </video>
        </ng-container>

        <div class="custom-sub-main">
          <span *ngFor="let img of images">
            <img [src]="img.url" alt="Uploaded Image" (click)="onImageClick(img)" class="product-sub-main-img"
              *ngIf="img.url && !img.url.endsWith('.mp4')" />
            <div class="videothum" (click)="onImageClick(img)" *ngIf="img.url?.endsWith('.mp4')">
              <video class="videoBackground product-sub-main-img" controls width="50%" style="pointer-events: none;">
                <source [src]="img.url" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
      <div class="productDetail px-3">
        <div class="row">
          
          <div class="col-lg-11 col-md-12 col-sm-12 col-xs-12">
            <h2 class="producttitle mt-4">
              {{productData?.Category3?.title == 'Other' ?
              (productData?.category3_name | uppercase) :
              productData?.Category3?.title | uppercase}}
            </h2>
            <h6>
              {{ productData?.sub_title | uppercase}}
            </h6>
          </div>
          <div class="col-md-1 d-flow p-2">
            <div class="d-flex justify-content-end align-items-center">
                  <span class="icon-container ms-auto" (click)="share()" [title]="'Share'">
              <img src="assets/images/share_storefron_profile.png" alt="Share" class="icon-img">
            </span>
            </div>
            
          </div>
        </div>
        <p class="mt-2 mb-0">Offered by: <a style="cursor: pointer; " (click)="navigatOnProfile()"
            class="text-g highcolor">{{productData?.Auth?.UserAuths[0]?.company_name || 'Null' | titlecase}}
          </a>
          <span class="successbox"><img src="assets/images/new_img/success.svg" class="" alt="">Trusted
            Partner </span>
        </p>
        <p class="mt-2 mb-0">
          <span *ngIf="productData?.stateDetails?.name"><img src="assets/images/locations.svg" class="img-fluid me-2"
              alt="location"></span>
          <span *ngIf="productData?.stateDetails?.name">{{
            productData?.cityDetails?.city | titlecase}}<span *ngIf="productData?.cityDetails !== null ">, </span>{{
            productData?.stateDetails?.name | titlecase }}</span>
        <p class="mt-2 mb-0"
          *ngIf="productData?.number_units_available != 'null' && productData?.number_units_available != null">
          <span>Available
            Quantity:</span> <span class="text-g"> {{productData?.number_units_available || 'N/A'}}</span>
        </p>
        

        <!-- <p class="mt-2 mb-0"
          *ngIf="productData?.price != 'null' && productData?.price != null  && productData?.Category1?.title !== 'Finance'">
          <span>Price: </span>
          <span class="text-g">{{ (productData?.price) ? (' ₹ ' + (productData?.price | commaSeparated)) + "/- " : 'On Request' }}</span>
      
          <span class="text-g" *ngIf="productData?.gst_inclusive != 'null' && productData?.gst_inclusive != null">
            {{ productData?.gst_inclusive == 'no' ? '(GST Exclusive)' : '(GST Inclusive)' }}
          </span>
        </p> -->


        <p class="mt-2 mb-0"
      *ngIf="productData?.Category1?.title !== 'Finance'">
  
      <span>Price: </span>

      <span class="text-g">
       <ng-container *ngIf="productData?.price !== null 
                         && productData?.price !== 'null' 
                         && productData?.price !== '0' 
                         && productData?.price !== 0; else onRequest">
      ₹ {{ productData?.price | commaSeparated }}/-
        </ng-container>
       <ng-template #onRequest>On Request</ng-template>
      </span>

      <span class="text-g"
        *ngIf="productData?.price !== null 
               && productData?.price !== 'null' 
               && productData?.price !== '0' 
               && productData?.price !== 0
               && productData?.gst_inclusive !== null 
               && productData?.gst_inclusive !== 'null'">
    {{ productData?.gst_inclusive === 'no' ? '(GST Exclusive)' : '(GST Inclusive)' }}
      </span>

    </p>

        <p class="mt-2 mb-0"
          *ngIf="productData?.price != 'null' && productData?.price != null && productData?.price != 0 && productData?.Category1?.title == 'Finance'">
          <span>Max Loan Up To:</span>
          <span class="highcolor"> ₹</span> <span class="text-g">{{ (productData?.price | commaSeparated) || 'Ask for
            Price' }}</span>
        </p>
        <p class="mt-2 mb-0"> <span>GST Number: </span> <span class=" text-g"> {{
            productData?.Auth?.UserAuths[0]?.gst_no || 'N/A' }}</span>
        </p>
        <!-- {{ownUser | json}} -->
        <form [formGroup]="loginForm" [ngClass]="{'disabled': ownUser}">
          <div class="row mt-3 mb-3" *ngIf="productData?.Industry?.industry_name != 'Services'">
            <div class="qty-div col-md-3 ">
              <input type="text" placeholder="Qty (Enter Here)" formControlName="quantity" class="form-control qty-text"
                maxlength="5" (keypress)="allowOnlyNumbers($event)">
            </div>
          </div>
          
          <div class="row mb-2 custom-checkbox" *ngIf="productData?.Category1?.title !== 'Finance'">
            <div class="col-md-12 d-flex ms-1 align-items-center">
              <label (change)="onToggleChange($event)">
                <input name="is_loan_required" type="checkbox" formControlName="is_loan_required" id="termsCheckbox" />
                <span class="checkmark"></span>
                <p class="ms-2 noaccount my-3">
                  Loan required ?
                </p>
              </label>
            </div>
          </div>
          <div class="productBtn d-flex justify-content-between mt-2 mb-3 row" [ngClass]="{'disabled': ownUser}">
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
              <button (click)="toggleWishlist()" class="productbtnborder" [disabled]="ownUser">
                <img [src]="isInWishlist ? 'assets/images/new_img/heartfull.png' : 'assets/images/new_img/heart.svg'"
                  alt="">
                <span class="">{{ isInWishlist == true ? 'Remove from Wishlist' : 'Add to Wishlist'
                  }}</span>
              </button>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
              <button (click)="toggleGetQuote()" class="productDetailbg" [disabled]="ownUser">
                <span>
                  {{productData?.price != 'null' && productData?.price != null && productData?.price != 0 ? 'Get a
                  Quote' :
                  'Enquire Now'}}
                </span>
              </button>
            </div>
          </div>
        </form>
        <div class="divider mt-3 mb-4"> </div>
        <div class="tags d-flex row">
          <div class="col-md-12  high-text">
            <h3 class="pheadsub"> Highlights</h3>
          </div>
          <div class="row" *ngIf="productData?.Industry?.industry_name == 'Machine'">
            <div class="data col-md-6"
              *ngIf="productData?.manufacturing_year != 'null' && productData?.manufacturing_year != null">
              <div class="custom-card mb-1">
                <div class="center-div">
                  <span class="m-0 type">Make Year</span><br>
                  <span id="below" class="m-0 value">
                    {{ productData?.manufacturing_year ? (productData?.manufacturing_year |
                    date:'yyyy')
                    : 'N/A' }}
                  </span>
                </div>
              </div>
            </div>
            <div class="data col-md-6"
              *ngIf="productData?.product_condition != 'null' && productData?.product_condition != null">
              <div class="custom-card mb-1">
                <div class="center-div">
                  <span class="m-0 type">Condition</span><br>
                  <span id="below" class="m-0 value">{{productData?.product_condition ||
                    'N/A' | titlecase}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="productData?.Industry?.industry_name == 'Services'">
            <div *ngIf="productData?.Category1?.title == 'Property'" class="row">
              <div class="data col-md-6"
                *ngIf="productData?.area_property !='null' && productData?.area_property !=null">
                <div class="custom-card mb-1">
                  <div class="center-div">
                    <span class="m-0 type">Area Of property(sqft)</span><br>
                    <span id="below" class="m-0 value">{{productData?.area_property }} sqft</span>
                  </div>
                </div>
              </div>
              <div class="data col-md-6" *ngIf="productData?.stateDetails != 'null'">
                <div class="custom-card mb-1">
                  <div class="center-div">
                    <span class="m-0 type">Location</span><br>
                    <span id="below" class="m-0 value">{{
                      productData?.cityDetails?.city | titlecase}}<span
                        *ngIf="productData?.cityDetails?.city != null && productData?.cityDetails?.city != 'null'">,
                      </span>{{
                      productData?.stateDetails?.name | titlecase }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="productData?.Category1?.title == 'Job Work'">

              <div *ngIf="productData?.job_type == 'Jobwork out source'" class="row">
                <div class="data col-md-6" *ngIf="productData?.lead_time != 'null' && productData?.lead_time != null">
                  <div class="custom-card mb-1">
                    <div class="center-div">
                      <span class="m-0 type">Lead Time</span><br>
                      <span id="below" class="m-0 value">{{productData?.lead_time }}</span>
                    </div>
                  </div>
                </div>
                <div class="data col-md-6" *ngIf="productData?.part_name != 'null' && productData?.part_name != null">
                  <div class="custom-card mb-1">
                    <div class="center-div">
                      <span class="m-0 type">Part Name</span><br>
                      <span id="below" class="m-0 value">{{productData?.part_name | titlecase}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="productData?.job_type == 'Job work seeker'" class="row">
                <div class="data col-md-6" *ngIf="productData?.lead_time != 'null' && productData?.lead_time != null">
                  <div class="custom-card mb-1">
                    <div class="center-div">
                      <span class="m-0 type">Lead Time</span><br>
                      <span id="below" class="m-0 value">{{productData?.lead_time }}</span>
                    </div>
                  </div>
                </div>
                <div class="data col-md-6" *ngIf="productData?.emp_count != 'null' && productData?.emp_count != null">
                  <div class="custom-card mb-1">
                    <div class="center-div">
                      <span class="m-0 type">Number Of Employee</span><br>
                      <span id="below" class="m-0 value">{{productData?.emp_count }}</span>
                    </div>
                  </div>
                </div>
                <div class="data col-md-6"
                  *ngIf="productData?.employee_Type !='null' && productData?.employee_Type !=null">
                  <div class="custom-card mb-1">
                    <div class="center-div">
                      <span class="m-0 type">Type Of Employee</span><br>
                      <span *ngFor="let type of productData?.employee_Type; let i = index" id="below" class="m-0 value">
                        {{ type || 'N/A' | titlecase}}<span *ngIf="i < (productData?.employee_Type.length - 1)">,
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="productData?.Category1?.title == 'HR Related'" class="row">
              <div class="data col-md-6"
                *ngIf="productData?.service_location !='null' && productData?.service_location !=null">
                <div class="custom-card mb-1">
                  <div class="center-div">
                    <span class="m-0 type">Service Location</span><br>
                    <span *ngFor="let type of productData?.service_location; let i = index" id="below"
                      class="m-0 value">
                      {{ type || 'N/A' | titlecase}}<span *ngIf="i < (productData?.service_location.length - 1)">,
                      </span>
                    </span>

                  </div>
                </div>
              </div>
              <div class="data col-md-6" *ngIf="productData?.experience != 'null' && productData?.experience != null">
                <div class="custom-card mb-1">
                  <div class="center-div">
                    <span class="m-0 type">Exprience</span><br>
                    <span *ngFor="let type of productData?.experience; let i = index" id="below" class="m-0 value">
                      {{ type || 'N/A' | titlecase}}<span *ngIf="i < (productData?.experience.length - 1)">, </span>
                    </span>

                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="productData?.Category1?.title == 'Finance'" class="row">
              <div class="data col-md-6" *ngIf="productData?.stateDetails != 'null'">
                <div class="custom-card mb-1">
                  <div class="center-div">
                    <span class="m-0 type">Location</span><br>
                    <span id="below" class="m-0 value">{{
                      productData?.cityDetails?.city | titlecase }}<span
                        *ngIf="productData?.cityDetails?.city != null && productData?.cityDetails?.city != 'null'">,
                      </span>{{
                      productData?.stateDetails?.name | titlecase }}</span>
                  </div>
                </div>
              </div>
              <div class="data col-md-6"
                *ngIf="productData?.interest_rate != 'null' && productData?.interest_rate !=null">
                <div class="custom-card mb-1">
                  <div class="center-div">
                    <span class="m-0 type">Interest Rate</span><br>
                    <span id="below" class="m-0 value"> {{productData?.interest_rate
                      || 'N/A' | titlecase}}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="row" *ngIf="productData?.Industry?.industry_name == 'Raw Material'">
            <div class="data col-md-6" *ngIf="productData?.specifications?.grade">
              <div class="custom-card mb-1">
                <div class="center-div">
                  <span class="m-0 type ">Material Grade</span><br>
                  <span id="below" class="m-0 value">{{productData?.specifications?.grade !== 'Other' ?
                    (productData?.specifications?.grade | titlecase):
                    productData?.grade_name | titlecase}}</span>
                </div>
              </div>
            </div>
            <div class="data col-md-6" *ngIf="productData?.Category3?.title">
              <div class="custom-card mb-1">
                <div class="center-div">
                  <span class="m-0 type">Sub Category Name</span><br>
                  <span id="below" class="m-0 value"> {{productData?.Category3?.title == 'Other' ?
                    (productData?.category3_name | titlecase) :
                    productData?.Category3?.title | titlecase }}</span>
                </div>
              </div>
            </div>
            <div class="data col-md-6"
              *ngIf="productData?.price != null && productData?.price != 'null' && productData?.price != 0">
              <div class="custom-card mb-1">
                <div class="center-div">
                  <span class="m-0 type ">Price Per Unit</span><br>
                  <span id="below" class="m-0 value">
                    ₹{{ productData?.price != null && productData?.price !== 'null' ? (productData?.price |
                    commaSeparated) : 'N/A' }}
                  </span>

                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="productData?.Industry?.industry_name == 'Tools'">
            <div class="data col-md-6  col-sm-12 col-xs-12"
              *ngIf="productData?.MaterialType != 'null' && productData?.MaterialType != null">
              <div class="custom-card mb-1">
                <div class="center-div">
                  <span class="m-0 type">Material Type</span><br>
                  <span id="below" class="m-0 value"> {{productData?.MaterialType?.name == 'Other' ?
                    (productData?.material_name | titlecase) :
                    productData?.MaterialType?.name | titlecase}}</span>
                </div>
              </div>
            </div>
            <div class="data col-md-6  col-sm-12 col-xs-12" *ngIf="productData?.Brand">
              <div class="custom-card">
                <div class="center-div">
                  <span class="m-0 type">Brand Name</span><br>
                  <span id="below" class="m-0 value">{{productData?.Brand?.brand_name == 'Other' ?
                    (productData?.brand_name | titlecase) :
                    productData?.Brand?.brand_name | titlecase}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="divider my-4"> </div>
        <div class="productOffers mt-3"
          *ngIf="productData?.offer_applicable == 'yes' && productData?.offer_details != 'null' && productData?.offer_details != null ">
          <div class="high-text">
            <p class="pheadsub"> Offers</p>
          </div>
          <h5><img src="assets/images/new_img/offertick.svg" class="" alt="" /> {{productData?.offer_details |
            titlecase}}
          </h5>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 overview-h pe-5 ps-5">
      <h4 class="text-center mt-4 o-heading"> Overview</h4>
      <div class="p-2">
        <h5 class="deschead">{{productData?.Category1?.title == 'Finance' ? 'Eligibility Criteria' :
          'Additional Key Features' }} </h5>
        <!-- <ul class="descdesc">
          <li> -->
        <pre class="preclass">{{productData?.description | titlecase}}</pre>
        <!-- </li>
        </ul> -->
        <h5 class="deschead" *ngIf="productData?.highlights != 'null' && productData?.highlights != null">
          {{productData?.Category1?.title == 'Finance' ? 'Documents
          Required' :
          'Specifications' }} </h5>

        <pre class="preclass"
          *ngIf="productData?.highlights != 'null' && productData?.highlights != null">{{productData?.highlights | titlecase}}</pre>
      </div>
    </div>
    <div class="col-md-12 overview-h pe-5 ps-5">
      <ul class="productinfo p-0">
        <div *ngIf="productData?.Industry?.industry_name == 'Machine'">
          <li *ngFor="let spec of filteredspecification">
            <span>{{ spec.key }}</span><span> {{ spec.value }}</span>
          </li>
          <li *ngIf="productData?.Brand?.brand_name !='null' && productData?.Brand?.brand_name != null"> <span> Brand
              Name</span> <span>
              {{productData?.Brand?.brand_name == 'Other' ? (productData?.brand_name | titlecase) :
              productData?.Brand?.brand_name | titlecase}}</span> </li>
          <li *ngIf="productData?.Brand?.brand_name !='null' && productData?.Brand?.brand_name != null"> <span>
              Country
              Name</span> <span>
              {{productData?.Brand?.brand_name == 'Other' ? (productData?.country_origin | titlecase) :
              productData?.Brand?.country_name | titlecase}}
            </span> </li>
          <li
            *ngIf="productData?.model_number !='null' && productData?.model_number !=null && productData?.model_number !=0 ">
            <span> Model Number
            </span> <span>
              {{productData?.model_number || 'N/A' | titlecase}}</span>
          </li>
          <li *ngIf="productData?.manufacturing_year !='null' && productData?.manufacturing_year !=null "> <span>
              Manufacturing Year
            </span> <span>
              {{productData?.manufacturing_year || 'N/A'}} Year</span> </li>
          <li *ngIf="productData?.automation_level !='null' && productData?.automation_level !=null "> <span> Automation
              Level</span> <span>
              {{productData?.automation_level || 'N/A' | titlecase}}</span> </li>
          <li *ngIf="productData?.product_condition !='null' && productData?.product_condition !=null "> <span>
              Condition
            </span> <span>
              {{productData?.product_condition || 'N/A' | titlecase}}</span> </li>
          <li
            *ngIf="productData?.product_condition=='Used' && productData?.under_hypothecation !='null' && productData?.under_hypothecation !=null ">
            <span>
              Hypothecation
            </span> <span>
              {{productData?.under_hypothecation || 'N/A' | titlecase}}</span>
          </li>
          <li *ngIf="productData?.power_consumption !='null' && productData?.power_consumption !=null"> <span> Power
              Consumption</span> <span>
              {{productData?.power_consumption || 'N/A' | titlecase}}</span> </li>
          <li *ngIf="productData?.operating_temp !='null' && productData?.operating_temp !=null"> <span> Operating
              Temperature</span> <span>
              {{productData?.operating_temp || 'N/A' | titlecase}}</span> </li>

          <li *ngIf="productData?.noise_level !='null' && productData?.noise_level !=null"> <span> Noise Level</span>
            <span>
              {{productData?.noise_level ||
              'N/A' | titlecase}}</span>
          </li>
          <li *ngIf="productData?.number_units_available !='null' && productData?.number_units_available !=null ">
            <span> Number Of Units Available
            </span> <span>
              {{productData?.number_units_available || 'N/A'}}</span>
          </li>
          <li *ngIf="productData?.price_type !='null' && productData?.price_type !=null "> <span> Price Type
            </span> <span>
              {{productData?.price_type || 'N/A' | titlecase}}</span> </li>
          <li *ngIf="productData?.price !='null' && productData?.price !=null && productData?.price != 0"> <span> Price
            </span> <span>
              ₹{{ productData?.price != null && productData?.price != 'null' ? (productData?.price | commaSeparated) :
              'N/A' }}
            </span>
          <li *ngIf="productData?.stateDetails !='null' && productData?.stateDetails !=null"> <span> Location </span>
            <span> {{
              productData?.cityDetails?.city | titlecase}}<span
                *ngIf="productData?.cityDetails?.city != null && productData?.cityDetails?.city != 'null'">, </span>{{
              productData?.stateDetails?.name | titlecase}}</span>
          </li>
          <li *ngIf="productData?.warranty_available =='yes'"> <span>
              Warranty Available
            </span> <span>
              {{productData?.warranty_available || 'N/A' | titlecase}}</span> </li>
          <li
            *ngIf="productData?.warranty_period !='null' && productData?.warranty_period !=0 && productData?.warranty_period !=null">
            <span> Warranty
              Period(month)</span> <span>
              {{productData?.warranty_period
              || 'N/A'}} Months</span>
          </li>
          <li *ngIf="productData?.after_sale_service !='null' && productData?.after_sale_service !=null "> <span>
              After Sale Service
            </span> <span>
              {{productData?.after_sale_service || 'N/A' | titlecase}}</span> </li>
          <li *ngIf="productData?.coverage_details !='null' && productData?.coverage_details !=null "> <span>
              Coverage Details
            </span> <span>
              {{productData?.coverage_details || 'N/A' | titlecase}}</span> </li>
          <li *ngIf="productData?.bulk_order_provision !='null' && productData?.bulk_order_provision !=null "> <span>
              Bulk Order Provision
            </span> <span>
              {{productData?.bulk_order_provision || 'N/A' | titlecase}}</span> </li>
          <li *ngIf="productData?.offer_applicable =='yes'"> <span>
              Offer Validity
            </span> <span>
              {{productData?.offer_validity || 'N/A' | titlecase}}</span> </li>
        </div>
        <div *ngIf="productData?.Industry?.industry_name == 'Services'">
          <li *ngFor="let spec of filteredspecification">
            <span>{{ spec.key }}</span><span> {{ spec.value }}</span>
          </li>
          <div *ngIf="productData?.Category1?.title == 'HR Related'">
            <li>
              <span>Experience</span>
              <span>
                <span *ngFor="let type of productData?.experience; let i = index">
                  {{ type || 'N/A' | titlecase}}<span *ngIf="i < (productData?.experience.length - 1)">, </span>
                </span>
              </span>
            </li>
            <li *ngIf="productData?.stateDetails !='null'"> <span> Location </span> <span> {{
                productData?.cityDetails?.city | titlecase}}<span
                  *ngIf="productData?.cityDetails?.city != null && productData?.cityDetails?.city != 'null'">, </span>{{
                productData?.stateDetails?.name | titlecase}}</span> </li>
            <li>
              <span>Service Location</span>
              <span>
                <span *ngFor="let type of productData?.service_location; let i = index">
                  {{ type || 'N/A' | titlecase}}<span *ngIf="i < (productData?.service_location.length - 1)">, </span>
                </span>
              </span>
            </li>
            <li *ngIf="productData?.key_features !='null' && productData?.key_features !=null"> <span> Key features
              </span> <span>
                {{productData?.key_features ||
                'N/A' | titlecase}}</span> </li>
            <li>
              <span>Service Type</span>
              <span>
                <span *ngFor="let type of productData?.service_type; let i = index">
                  {{ type || 'N/A' | titlecase}} <span *ngIf="i < (productData?.service_type.length - 1)">, </span>
                </span>
              </span>
            </li>
          </div>
          <div *ngIf="productData?.Category1?.title == 'Property'">
            <li
              *ngIf="productData?.area_property !='null' && productData?.area_property !=null && productData?.area_property !=0">
              <span> Property Area(sqft)
              </span> <span>
                {{productData?.area_property || 'N/A'}} sqft</span>
            </li>
            <li *ngIf="productData?.is_property_build !='null' && productData?.is_property_build !=null"> <span>
                Property Built
              </span> <span>
                {{productData?.is_property_build || 'N/A' | titlecase}}</span> </li>
            <li *ngIf="productData?.manufacturing_year !='null' && productData?.manufacturing_year !=null"> <span>
                Manufacturing Year
              </span> <span>
                {{productData?.manufacturing_year || 'N/A'}} Year</span> </li>
            <li *ngIf="productData?.price_type !='null' && productData?.price_type !=null "> <span> Price Type
              </span> <span>
                {{productData?.price_type || 'N/A' | titlecase}}</span> </li>
            <li *ngIf="productData?.price !='null' && productData?.price !=null && productData?.price != 0"> <span>
                Price
              </span> <span>
                ₹{{ productData?.price != null && productData?.price !== 'null' ? (productData?.price | commaSeparated) + '/-'
                : 'N/A' }}
              </span>
            </li>

            <li *ngIf="productData?.zip !='null' && productData?.zip !=null"> <span>
                Zip Code
              </span> <span>
                {{productData?.zip || 'N/A'}}</span> </li>
            <li *ngIf="productData?.stateDetails !='null'"> <span> Location </span> <span> {{
                productData?.cityDetails?.city | titlecase}}<span
                  *ngIf="productData.cityDetails?.city != null && productData?.cityDetails?.city != 'null'">, </span>{{
                productData?.stateDetails?.name | titlecase }}</span> </li>
            <li
              *ngIf="productData?.ceiling_height !='null' && productData?.ceiling_height !=null && productData?.ceiling_height !=0">
              <span> Ceiling
                Height
              </span> <span>
                {{productData?.ceiling_height || 'N/A'}}</span>
            </li>
            <li
              *ngIf="productData?.number_floors !='null' && productData?.number_floors !=null && productData?.number_floors !=0">
              <span> Number Of
                Floors
              </span> <span>
                {{productData?.number_floors || 'N/A'}}</span>
            </li>
            <li
              *ngIf="productData?.floor_load_capicity !='null' && productData?.floor_load_capicity !=null && productData?.floor_load_capicity !=0">
              <span>
                Floor Load Capacity
              </span> <span>
                {{productData?.floor_load_capicity || 'N/A'}}</span>
            </li>
            <li *ngIf="productData?.no_doors !='null' && productData?.no_doors !=null && productData?.no_doors !=0">
              <span> Number Of Doors
              </span> <span>
                {{productData?.no_doors || 'N/A'}}</span>
            </li>
            <li *ngIf="productData?.dock_doors_name !='null' && productData?.dock_doors_name !=null"> <span> Dock Doors
              </span> <span>
                {{productData?.dock_doors_name || 'N/A' | titlecase}}</span> </li>
            <li *ngIf="productData?.column_spacing !='null' && productData?.column_spacing !=null"> <span> Column
                Spacing
              </span> <span>
                {{productData?.column_spacing || 'N/A' | titlecase}}</span> </li>
            <li *ngIf="productData?.power_supply !='null' && productData?.power_supply !=null"> <span> Power Supply
              </span> <span>
                {{productData?.power_supply || 'N/A' | titlecase}}</span> </li>
            <li *ngIf="productData?.water_supply_name !='null' && productData?.water_supply_name !=null"> <span> Water
                Supply
              </span> <span>
                {{productData?.water_supply_name || 'N/A' | titlecase}}</span> </li>
            <li *ngIf="productData?.sewer_system_name !='null' && productData?.sewer_system_name !=null"> <span> Sewer
                System
              </span> <span>
                {{productData?.sewer_system_name || 'N/A' | titlecase}}</span> </li>
            <li *ngIf="productData?.hvac_system_name !='null' && productData?.hvac_system_name !=null"> <span> HVAC
                System
              </span> <span>
                {{productData?.hvac_system_name || 'N/A' | titlecase}}</span> </li>
            <li *ngIf="productData?.sprinkler_system_name !='null' && productData?.sprinkler_system_name !=null"> <span>
                Sprinkler
                System
              </span> <span>
                {{productData?.sprinkler_system_name || 'N/A' | titlecase}}</span> </li>
            <li *ngIf="productData?.telecommunications !='null' && productData?.telecommunications !=null"> <span>
                Telecommunications
              </span> <span>
                {{productData?.telecommunications || 'N/A' | titlecase}}</span> </li>
            <li *ngIf="productData?.parking !='null' && productData?.parking !=null"> <span> Parking
              </span> <span>
                {{productData?.parking || 'N/A' | titlecase}}</span> </li>

            <li *ngIf="productData?.distance_highway !='null' && productData?.distance_highway !=null"> <span> Highways
                Proximity(Km)</span> <span>
                {{productData?.distance_highway || 'N/A'}} km</span> </li>
            <li *ngIf="productData?.distance_station !='null' && productData?.distance_station !=null"> <span> Rail /
                Airports Proximity(km)</span> <span>
                {{productData?.distance_station || 'N/A'}} km</span>
            </li>
            <li *ngIf="productData?.public_proximity !='null' && productData?.public_proximity !=null"> <span> Public
                Transport Availability</span>
              <span>
                {{productData?.public_proximity|| 'N/A' | titlecase}}</span>
            </li>
            <li *ngIf="productData?.ports_proximity !='null' && productData?.ports_proximity !=null"> <span> Ports
                Proximity</span> <span>
                {{productData?.ports_proximity || 'N/A' | titlecase}}</span> </li>
          </div>
          <div *ngIf="productData?.Category1?.title == 'Job Work'">
            <li *ngIf="productData?.machines_name?.length > 0">
              <span>Machines</span>
              <span>
                <span *ngFor="let type of productData?.machines_names; let i = index">
                  {{ type || 'N/A'| titlecase }}<span *ngIf="i < (productData?.machines_names.length - 1)">, </span>
                </span>
              </span>
            </li>
            <li *ngIf="productData?.lead_time !='null' && productData?.lead_time !=null"> <span> Lead Time</span>
              <span>
                {{productData?.lead_time
                || 'N/A'}}</span>
            </li>
            <li *ngIf="productData?.stateDetails !='null'"> <span> Location </span> <span> {{
                productData?.cityDetails?.city | titlecase}}<span
                  *ngIf="productData?.cityDetails?.city != null && productData?.cityDetails?.city != 'null'">, </span>{{
                productData?.stateDetails?.name | titlecase}}</span> </li>
            <div *ngIf="productData?.job_type == 'Jobwork out source'">
              <li *ngIf="productData?.job_type !='null' && productData?.job_type !=null"> <span> Job Type
                </span>
                <span>
                  {{productData?.job_type
                  || 'N/A' | titlecase}}</span>
              </li>
              <li *ngIf="productData?.part_name !='null' && productData?.part_name !=null"> <span> Part Name </span>
                <span>
                  {{productData?.part_name
                  || 'N/A' | titlecase}}</span>
              </li>
              <li *ngIf="productData?.part_description !='null' && productData?.part_description !=null"> <span> Part
                  Description</span>
                <span>
                  {{productData?.part_description
                  || 'N/A' | titlecase}}</span>
              </li>
              <li *ngIf="productData?.requirement_brief !='null' && productData?.requirement_brief !=null"> <span>
                  Requirement In Brief</span>
                <span>
                  {{productData?.requirement_brief
                  || 'N/A' | titlecase}}</span>
              </li>
            </div>
            <div *ngIf="productData?.job_type == 'Job work seeker'">
              <li *ngIf="productData?.job_type !='null' && productData?.job_type !=null"> <span> Job Type
                </span>
                <span>
                  {{productData?.job_type
                  || 'N/A' | titlecase}}</span>
              </li>
              <li *ngIf="productData?.emp_count !='null' && productData?.emp_count !=null"> <span> Number Of Employee
                </span>
                <span>
                  {{productData?.emp_count
                  || 'N/A'}}</span>
              </li>
              <li *ngIf="productData?.employee_Type !='null' && productData?.employee_Type !=null">
                <span>Employee Type</span>
                <span>
                  <span *ngFor="let type of productData?.employee_Type; let i = index">
                    {{ type || 'N/A' | titlecase }}<span *ngIf="i < (productData?.employee_Type.length - 1)">, </span>
                  </span>
                </span>
              </li>
              <li *ngIf="productData?.additional_services !='null' && productData?.additional_services !=null"> <span>
                  Additional Services</span>
                <span>
                  {{productData?.additional_services
                  || 'N/A' | titlecase}}</span>
              </li>
            </div>
          </div>
          <div *ngIf="productData?.Category1?.title == 'Finance'">
            <li *ngIf="productData?.interest_rate !='null' && productData?.interest_rate !=null">
              <span>
                Interest Rate</span>
              <span>
                {{productData?.interest_rate
                || 'N/A' | titlecase}}</span>
            </li>
            <li *ngIf="productData?.loan_repayment_period !='null' && productData?.loan_repayment_period !=null">
              <span>
                Loan Repayment Period(in years)</span>
              <span>
                {{productData?.loan_repayment_period
                || 'N/A'}} Years</span>
            </li>
            <!-- <li *ngIf="productData?.highlights !='null' && productData?.highlights !=null">
              <span>
                Documents Required</span>
              <span>
                {{productData?.highlights
                || 'N/A' | titlecase}}</span>
            </li> -->
            <li *ngIf="productData?.price !='null' && productData?.price !=null && productData?.price != 0"> <span> Max
                Loan Up To
              </span> <span>
                ₹{{ productData?.price != null && productData?.price !== 'null' ? (productData?.price | commaSeparated)
                : 'N/A' }}
              </span>
            </li>
            <li *ngIf="productData?.stateDetails !='null'"> <span> Location </span> <span> {{
                productData?.cityDetails?.city | titlecase}}<span
                  *ngIf="productData?.cityDetails?.city != null && productData?.cityDetails?.city != 'null'">, </span>{{
                productData?.stateDetails?.name | titlecase}}</span> </li>
          </div>
        </div>
        <div *ngIf="productData?.Industry?.industry_name == 'Raw Material'">
          <li *ngFor="let spec of filteredspecification">
            <span>{{ spec.key }}</span>
            <span>
              {{ spec.key == 'Grade' && spec.value == 'Other' ? productData?.grade_name : spec.value }}
            </span>
          </li>
          <li *ngIf="productData?.Brand?.brand_name !='null' && productData?.Brand?.brand_name !=null"> <span> Brand
              Name</span> <span>
              {{productData?.Brand?.brand_name == 'Other' ? (productData?.brand_name | titlecase) :
              productData?.Brand?.brand_name | titlecase}}</span> </li>
          <!-- <li *ngIf="productData?.specifications?.grade"> <span>
              Material Grade</span> <span>
              {{productData?.specifications?.grade != 'Other' ? productData?.specifications?.grade :
              productData?.grade_name | titlecase}}</span> </li> -->
          <li *ngIf="productData?.material_name !='null' && productData?.material_name !=null"> <span>
              Material Name</span> <span>
              {{productData?.material_name || 'N/A' | titlecase}}</span> </li>
          <li *ngIf="productData?.unit_measure !='null' && productData?.unit_measure !=null"> <span>
              Unit Of Measure</span> <span>
              {{productData?.unit_measure || 'N/A' | titlecase}}</span> </li>
          <li *ngIf="productData?.price_type !='null' && productData?.price_type !=null "> <span> Price Type
            </span> <span>
              {{productData?.price_type || 'N/A'}}</span> </li>
          <li *ngIf="productData?.price !='null' && productData?.price !=null && productData?.price != 0"> <span> Price
            </span> <span>
              ₹{{ productData?.price != null && productData?.price !== 'null' ? (productData?.price | commaSeparated) :
              'N/A' }}
            </span>
          </li>
          <li *ngIf="productData?.packaging_details !='null' && productData?.packaging_details !=null "> <span>
              Packaging Details
            </span> <span>
              {{productData?.packaging_details || 'N/A' | titlecase}}</span> </li>
          <li *ngIf="productData?.offer_applicable =='yes'"> <span>
              Offer Validity
            </span> <span>
              {{productData?.offer_validity || 'N/A'}}</span> </li>
          <li *ngIf="productData?.payment_terms !='null' && productData?.payment_terms !=null "> <span>
              Payment Terms
            </span> <span>
              {{productData?.payment_terms || 'N/A' | titlecase}}</span> </li>
          <li *ngIf="productData?.stateDetails !='null'"> <span> Location </span> <span> {{
              productData?.cityDetails?.city | titlecase}}<span
                *ngIf="productData?.cityDetails?.city != null && productData?.cityDetails?.city != 'null'">, </span>{{
              productData?.stateDetails?.name | titlecase }}</span> </li>
          <li *ngIf="productData?.minimum_quantity_required !='null' && productData?.minimum_quantity_required !=null ">
            <span>
              Minimum Quantity Required
            </span> <span>
              {{productData?.minimum_quantity_required || 'N/A'}}/{{productData?.mqu}}</span>
          </li>
          <li *ngIf="productData?.lead_time !='null' && productData?.lead_time !=null"> <span> Lead Time</span>
            <span>
              {{productData?.lead_time || 'N/A'}}</span>
          </li>
          <li
            *ngIf="productData?.safety_stock !='null' && productData?.safety_stock !=null && productData?.safety_stock !=0">
            <span> Safety Stock</span>
            <span>
              {{productData?.safety_stock || 'N/A'}}/{{productData?.safety_unit}}</span>
          </li>
          <li *ngIf="productData?.expiration_date !='null' && productData?.expiration_date !=null"> <span> Expiration
              Date</span>
            <span>
              {{productData?.expiration_date || 'N/A'}}</span>
          </li>
          <li *ngIf="productData?.shipping_terms !='null' && productData?.shipping_terms !=null"> <span>
              Logistics</span> <span>
              {{productData?.shipping_terms ||
              'N/A' | titlecase}}</span> </li>
          <li
            *ngIf="productData?.warranty_period !=0 && productData?.warranty_period !='null' && productData?.warranty_period !=null">
            <span> Warranty
              Period(month)</span> <span>
              {{productData?.warranty_period
              || 'N/A'}} Months</span>
          </li>
        </div>
        <div *ngIf="productData?.Industry?.industry_name == 'Tools'">
          <li *ngFor="let spec of filteredspecification">
            <span>{{ spec.key }}</span><span> {{ spec.value }}</span>
          </li>
          <li *ngIf="productData?.Brand?.brand_name !='null' && productData?.Brand?.brand_name !=null"> <span> Brand
              Name</span> <span>
              {{productData?.Brand?.brand_name == 'Other' ? (productData?.brand_name | titlecase) :
              productData?.Brand?.brand_name | titlecase}}</span> </li>
          <li *ngIf="productData?.MaterialType"> <span>
              Material
              Type
            </span> <span>
              {{productData?.MaterialType?.name == 'Other' ? (productData?.material_name | titlecase) :
              productData?.MaterialType?.name | titlecase}}</span> </li>
          <li *ngIf="productData?.tool_name !='null' && productData?.tool_name !=null"> <span> Tool Name </span>
            <span>
              {{productData?.tool_name || 'N/A' | titlecase}}</span>
          </li>
          <li *ngIf="productData?.model_number !='null' && productData?.model_number !=null"> <span> Tool Model
            </span>
            <span>
              {{productData?.model_number || 'N/A'}}</span>
          </li>
          <li *ngIf="productData?.diameter !='null' && productData?.diameter !=null"> <span> Diameter </span>
            <span>
              {{productData?.diameter || 'N/A'}}/{{productData?.dunit}}</span>
          </li>
          <li *ngIf="productData?.length !='null' && productData?.length !=null"> <span> Length </span>
            <span>
              {{productData?.length || 'N/A'}}/{{productData?.lunit}}</span>
          </li>
          <li *ngIf="productData?.width !='null' && productData?.width !=null"> <span> Width </span>
            <span>
              {{productData?.width || 'N/A'}}/{{productData?.wunit}}</span>
          </li>
          <li *ngIf="productData?.height !='null' && productData?.height !=null"> <span> Height </span>
            <span>
              {{productData?.height || 'N/A'}}/{{productData?.hunit}}</span>
          </li>
          <li
            *ngIf="productData?.cutting_speed !='null' && productData?.cutting_speed !=null && productData?.cutting_speed !=0">
            <span> Cutting Speed(RPM)
            </span>
            <span>
              {{productData?.cutting_speed || 'N/A'}} RPM</span>
          </li>
          <li *ngIf="productData?.feed_speed !='null' && productData?.feed_speed !=null && productData?.feed_speed !=0">
            <span> Feed Rate </span>
            <span>
              {{productData?.feed_speed }}</span>
          </li>
          <li *ngIf="productData?.depth_cut !='null' && productData?.depth_cut !=null &&  productData?.depth_cut !=0">
            <span> Depth Cut (in cm)</span>
            <span>
              {{productData?.depth_cut}} cm</span>
          </li>
          <li
            *ngIf="productData?.tolerance !== 'null' && productData?.tolerance !== null && productData?.tolerance != 0 ">
            <span> Tolerance</span>
            <span>
              {{productData?.tolerance
              ||
              'N/A' | titlecase}}</span>
          </li>
          <li *ngIf="productData?.surface_finish !='null' && productData?.surface_finish !=null"> <span>
              Surface Finish</span> <span>
              {{productData?.surface_finish || 'N/A' | titlecase}}</span>
          </li>
          <li *ngIf="productData?.cooling_requirements !='null' && productData?.cooling_requirements !=null"> <span>
              Cooling Requirement</span> <span>
              {{productData?.cooling_requirements || 'N/A' | titlecase}}</span>
          </li>
          <li *ngIf="productData?.tool_life !='null' && productData?.tool_life !=null"> <span> Tool Life</span> <span>
              {{productData?.tool_life
              ||
              'N/A' | titlecase}}</span> </li>
          <li *ngIf="productData?.resharpening_capability !='null' && productData?.resharpening_capability !=null">
            <span> Re-sharpening Capability</span>
            <span>
              {{productData?.resharpening_capability ||
              'N/A' | titlecase}}</span>
          </li>
          <li *ngIf="productData?.insert_capability !='null' && productData?.insert_capability !=null"> <span> Insert
              Compatibility</span> <span>
              {{productData?.insert_capability || 'N/A' | titlecase}}</span> </li>
          <li *ngIf="productData?.unit_measure !='null' && productData?.unit_measure !=null"> <span> Unit Of Measure
            </span>
            <span>
              {{productData?.unit_measure || 'N/A' | titlecase}}</span>
          </li>
          <li *ngIf="productData?.price_type !='null' && productData?.price_type !=null "> <span> Price Type
            </span> <span>
              {{productData?.price_type || 'N/A'}}</span> </li>
          <li *ngIf="productData?.price !='null' && productData?.price !=null && productData?.price != 0"> <span> Price
            </span> <span>
              ₹{{ productData?.price != null && productData?.price !== 'null' ? (productData?.price | commaSeparated) :
              'N/A' }}
            </span>
          </li>

          <li *ngIf="productData?.payment_terms !='null' && productData?.payment_terms !=null"> <span>
              Payment Terms</span> <span>
              {{productData?.payment_terms || 'N/A' | titlecase}}</span>
          </li>
          <li *ngIf="productData?.select_packaging !='null' && productData?.select_packaging !=null"> <span>
              Packaging</span> <span>
              {{productData?.select_packaging || 'N/A' | titlecase}}</span> </li>
          <li *ngIf="productData?.minimum_quantity_required !='null' && productData?.minimum_quantity_required !=null">
            <span> Minimum Order Quantity</span>
            <span>
              {{productData?.minimum_quantity_required ||
              'N/A'}}/{{productData?.mqu ||
              'N/A'}}</span>
          </li>
          <li *ngIf="productData?.inventory !='null' && productData?.inventory !=null && productData?.inventory != 0">
            <span> Available Stock</span>
            <span>
              {{productData?.inventory }}/{{productData?.iunit}}</span>
          </li>
          <li *ngIf="productData?.lead_time !='null' && productData?.lead_time !=null"> <span> Lead Time</span>
            <span>
              {{productData?.lead_time || 'N/A'}}</span>
          </li>
          <li *ngIf="productData?.shipping_terms !='null' && productData?.shipping_terms !=null"> <span>
              Logistics</span> <span>
              {{productData?.shipping_terms || 'N/A' | titlecase}}</span> </li>
          <li *ngIf="productData?.regulatory_compliance !='null' && productData?.regulatory_compliance !=null"> <span>
              Regulatory Compliance</span> <span>
              {{productData?.regulatory_compliance|| 'N/A' | titlecase}}</span>
          </li>
          <li *ngIf="productData?.offer_applicable =='yes'"> <span>
              Offer Validity
            </span> <span>
              {{productData?.offer_validity || 'N/A'}}</span> </li>
          <li
            *ngIf="productData?.warranty_period !='null' && productData?.warranty_period !=0 && productData?.warranty_period !=null">
            <span> Warranty Period(month)</span>
            <span>
              {{productData?.warranty_period|| 'N/A'}} Months</span>
          </li>
          <li *ngIf="productData?.stateDetails !='null'"> <span> State </span><span>{{
              productData?.stateDetails?.name | titlecase}}</span> </li>
        </div>
        <li *ngIf="productData?.AMC !='null' && productData?.AMC !=0 && productData?.AMC !=null"> <span> Annual
            Maintenance Contract (AMC)</span>
          <span>
            {{productData?.AMC
            || 'N/A'}} Year</span>
        </li>
        <li *ngIf="productData?.SLA !='null' && productData?.SLA !=0  && productData?.SLA !=null"> <span> Service Level
            Agreement (SLA)</span>
          <span>
            {{productData?.SLA ||
            'N/A'}} Months</span>
        </li>
      </ul>
    </div>
  </div>
</div>
<div class="container-fluid mt-3 px-4">
</div>
<div class="container-fluid mt-5 px-3" *ngIf="stoken">
  <div class="industry bgcolorss mt-4 pt-4 pb-4 px-4" *ngIf="moreFromSeller?.length !== 0">
    <div class="align-items-center row">
      <span class="mb-0 title-pp text-center mb-4">More from the Seller</span>
      <!-- Loop through moreFromSeller array -->
      <div class="col-lg-3 col-md-6 mb-4" *ngFor="let prod of moreFromSeller">
        <!-- New box with styling -->
        <div class="normalbox" style="cursor: pointer;">
          <div (click)="viewSingleProduct(prod.id, prod?.Industry?.industry_name)">
            <span class="newtick" *ngIf="prod?.is_new === true">New</span>
            <div class="normalboximg" *ngIf="prod">
              <img *ngIf="prod.Media && prod.Media.length > 0" [src]="prod.Media[0]?.url" class="img-fluid normalimg"
                alt="{{ prod.title }}" />
            </div>
            <div class="normalboxDetail">
              <!-- <div class="catServices">{{ prod?.Industry?.industry_name }}</div><span *ngIf="prod?.punit">/{{prod?.punit ||
                  ''}}</span> -->
              <h5>
                {{ (prod?.Category3?.title === 'Other' ? (prod?.category3_name | titlecase) : (prod?.Category3?.title |
                titlecase)) }}

              </h5>
              <p class="location d-flex align-items-center">
                <span *ngIf="prod?.stateDetails?.name"><img src="assets/images/locations.svg" class="img-fluid me-2"
                    alt="location"></span>
                <span *ngIf="prod?.stateDetails?.name">{{
                  prod?.cityDetails?.city | titlecase}}<span *ngIf="prod?.cityDetails !== null">, </span>{{
                  prod?.stateDetails?.name | titlecase }}</span>
              </p>
              <!-- <p class="location d-flex align-items-center">
                {{prod?.UserAuth?.company_name}}

            </p> -->
              <div class="price"
                *ngIf="prod?.price != 'null' && prod?.price != null && prod?.price != 0 && prod?.Category1?.title !== 'Finance'">
                Price
                <span>₹{{ (prod?.price | commaSeparated) }}</span>
              </div>
              <div class="price"
                *ngIf="prod?.price != 'null' && prod?.price != null && prod?.price != 0 && prod?.Category1?.title == 'Finance'">
                Max Loan Up To
                <span>₹{{ (prod?.price | commaSeparated) }}</span>
              </div>

              <div class="ContactSeller mt-2">
                <a> Contact the Seller</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 d-flex justify-content-center" *ngIf="viweall">
        <button class="btn viewall" (click)="viewAllProductsFromSeller('moreFromSeller')">View All</button>
      </div>
      <div class="col-md-12 d-flex justify-content-center" *ngIf="viweless">
        <button class="btn viewall" (click)="viewLessProductsFromSeller('lessFromSeller')">View Less</button>
      </div>

    </div>
  </div>

</div>
<div class="container-fluid mt-3 px-4" *ngIf="stoken">
  <div class="industry bgcolorss mt-4 pt-4 pb-4 px-4" *ngIf="relatedProducts?.length !== 0">
    <div class="align-items-center row">
      <span class="mb-0 title-pp text-center mb-4">Related Products</span>
      <div class="col-lg-3 col-md-6 mb-4" *ngFor="let prod of relatedProducts">
        <div class="normalbox" style="cursor: pointer;">
          <div (click)="viewSingleProduct(prod.id, prod?.Industry?.industry_name)">
            <span class="newtick" *ngIf="prod?.is_new === true">New</span>
            <div class="normalboximg" *ngIf="prod">
              <img *ngIf="prod.Media && prod.Media.length > 0" [src]="prod.Media[0]?.url" class="img-fluid normalimg"
                alt="{{ prod.title }}" />
            </div>
            <div class="normalboxDetail">
              <!-- <div class="catServices">{{ prod?.Industry?.industry_name }}</div> -->
              <h5>{{prod?.Category3?.title == 'Other' ? (prod?.category3_name | titlecase) :
                (prod?.Category3?.title | titlecase) }}</h5>
              <p class="location d-flex align-items-center">
                <span *ngIf="prod?.stateDetails?.name"><img src="assets/images/locations.svg" class="img-fluid me-2"
                    alt="location"></span>
                <span *ngIf="prod?.stateDetails?.name">{{
                  prod?.cityDetails?.city | titlecase}}<span *ngIf="prod?.cityDetails !== null ">, </span>{{
                  prod?.stateDetails?.name | titlecase}}</span>
                <!-- <span> {{ prod.location }}</span> -->
              </p>
              <!-- <p class="location d-flex align-items-center">
                {{prod?.UserAuth?.company_name}}

            </p> -->
              <div class="price"
                *ngIf="prod?.price != 'null' && prod?.price != null && prod?.price != 0 && prod?.Category1?.title !== 'Finance'">
                Price
                <span>₹{{ (prod?.price | commaSeparated) }}</span>
              </div>
              <div class="price"
                *ngIf="prod?.price != 'null' && prod?.price != null && prod?.price != 0 && prod?.Category1?.title == 'Finance'">
                Max Loan Up To
                <span>₹{{ (prod?.price | commaSeparated) }}</span>
              </div>
              <div class="ContactSeller mt-2">
                <a> Contact the Seller</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 d-flex justify-content-center" *ngIf="viweallrel">
        <button class="btn viewall" (click)="viewAllProductsFromRelated('relatedProducts')">View All</button>
      </div>
      <div class="col-md-12 d-flex justify-content-center" *ngIf="viwelessrel">
        <button class="btn viewall" (click)="viewLessProductsFromRelated('lessrelatedProducts')">View
          Less</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="stoken">
  <app-footer></app-footer>
</div>